import { render, staticRenderFns } from "./sent-record.vue?vue&type=template&id=a123602a&scoped=true"
import script from "./sent-record.vue?vue&type=script&lang=ts"
export * from "./sent-record.vue?vue&type=script&lang=ts"
import style0 from "./sent-record.vue?vue&type=style&index=0&id=a123602a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a123602a",
  null
  
)

export default component.exports